import React from "react";
import "../style/teammember.css"; // Verify this path matches your folder structure
import Naila from "../assets/Naila.png";
import Joana from "../assets/Joana.png";
import Bushira from "../assets/Bushira.png";
import yellowcicle from "../assets/yellowcircle.png";

const TeamMembers = () => {
  // Team member data array
  const teamMembers = [
    {
      id: 1,
      name: "Naila Jahangir",
      image: Naila,
      title: "Operations Manager/Nominated Individual",
      department: "(Director of Care)",
      qualifications:
        "BSc Psychology, 15+ years experience in health and social care",
      bio: "As Operations Manager at Serenity Residential Care Ltd, I have dedicated over 15 years to making a difference in people's lives. My journey from Support Worker to senior management has been fueled by my BSc in Psychology, a deep compassion for others, and a passion for inspiring my team to achieve the highest standards of care. I believe that great care is built on trust, respect, and genuine human connection — values I strive to nurture every day for both our residents and our staff.",
    },
    {
      id: 2,
      name: "Joanna Davies",
      image: Joana,
      title: "Registered Manager",
      department: "(Manager)",
      qualifications:
        "NVQ Level 5 in Health and Social Care, 15+ years in health and social care",
      bio: "As Registered Manager at Serenity Residential Care Ltd, I’m the friendly face who’ll welcome you in — and the no-nonsense voice who’ll make sure things get done right. With years of leadership experience under my belt, I believe in running a happy, well-organised home where both residents and staff can thrive.",
    },
    {
      id: 3,
      name: "Bushra Jahangir",
      image: Bushira,
      title: "Director",
      department: "(Director of Finance)",
      qualifications: "BSc Human Biology, 10+ years as an accountant (ACCA)",
      bio: "I am a realist who believes in hard work, dedication, and achieving results. With over 10 years of experience in finance and as a certified accountant, I bring both expertise and a logical approach to managing the financial aspects of our care company. My extensive educational background has equipped me with the skills to analyze challenges thoroughly and provide practical, goal-oriented solutions. Beyond numbers, I value building strong relationships and working well with people.",
    },
  ];

  return (
    <div className="meet-section4-teams">
      {teamMembers.map((member) => (
        <div key={member.id} className="meet-section4-div-items">
          <img src={yellowcicle} alt="yellow circle" className="card-icon" />
          <div className="card-content">
            <img
              src={member.image}
              alt={`${member.name}, ${member.title}`}
              loading="lazy"
              onError={(e) => (e.target.src = "/assets/fallback.png")}
            />
            <h2>{member.name}</h2>
            <p className="title">{member.title}</p>
            <p className="department">{member.department}</p>
            <p className="qualifications">{member.qualifications}</p>
            <p className="bio">{member.bio}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamMembers;
